import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../utils/constants";
import { getAuthToken } from "../../utils/authToken";

export const getHomePageContent = createAsyncThunk(
  "homePage/getHomePageContent",
  async (_, thunkAPI) => {
    try {
      const res = await axios.get(`${BASE_URL}/homepage`);
      return res.data;
    } catch (err) {
      console.log('Помилка при отриманні контенту головної сторінки:', err);
      return thunkAPI.rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const updateHomePageContent = createAsyncThunk(
  "homePage/updateHomePageContent",
  async (content, thunkAPI) => {
    try {
      const token = getAuthToken(thunkAPI.getState);
      
      if (!token) {
        throw new Error('Токен не знайдено');
      }
      
      const headers = {
        Authorization: `Bearer ${token}`
      };
      
      if (!(content instanceof FormData)) {
        headers['Content-Type'] = 'application/json';
      }
      
      const res = await axios.post(`${BASE_URL}/homepage`, content, {
        headers: headers
      });
      return res.data;
    } catch (err) {
      console.log('Помилка при оновленні контенту головної сторінки:', err);
      return thunkAPI.rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

const homePageSlice = createSlice({
  name: "homePage",
  initialState: {
    content: null,
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getHomePageContent.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getHomePageContent.fulfilled, (state, action) => {
        state.isLoading = false;
        state.content = action.payload;
      })
      .addCase(getHomePageContent.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(updateHomePageContent.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateHomePageContent.fulfilled, (state, action) => {
        state.isLoading = false;
        state.content = action.payload;
      })
      .addCase(updateHomePageContent.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default homePageSlice.reducer;



